export default __webpack_public_path__ + "static/media/sample_1.17d6411b.png";